import { formatUTCDateDash } from "@demandproai/shared";
import CaseDetailsCell from "./CaseDetailsCell";
import CaseActionControls from "../ui-control/CaseActionControls";
import ClientNameCell from "../common/ClientNameCell";
import DefendantNameCell from "../common/DefendantNameCell";
import TableRowDivider from "../common/TableRowDivider";
import XCircularProgress from "../common/XCircularProgress";
import { caseListRowClasses } from "../common/caseListClasses";
import { TOUR_TARGETS } from "../../constants/tourTargets";
import { cn } from "../../utils/classNames";
import SAMPLE_CASE from "../../tours/sampleCase";

// The real controls navigate, download and delete, so the sample keeps them for
// their looks only. Nothing in the row reveals itself on hover, so making the
// whole row unclickable costs it nothing
const inertRowClasses = "pointer-events-none";

const statusCellClasses = "align-middle text-center";

const statusWrapperClasses = "inline-flex justify-center";

const actionsCellClasses = "w-action-column min-w-action-column";

const SAMPLE_DEMAND_PROGRESS = 100;

const SAMPLE_COLUMN_COUNT = 7;

const noop = () => {};

const SampleCaseRow = () => (
   <>
      <tr
         className={cn(caseListRowClasses, inertRowClasses)}
         data-tour={TOUR_TARGETS.CASE_LIST_SAMPLE_ROW}
      >
         <CaseDetailsCell caseData={SAMPLE_CASE} />

         <td />

         <td>
            <ClientNameCell caseData={SAMPLE_CASE} />
         </td>

         <td>
            <DefendantNameCell caseData={SAMPLE_CASE} />
         </td>

         <td>{formatUTCDateDash(SAMPLE_CASE.updatedOn)}</td>

         <td className={statusCellClasses} data-tour={TOUR_TARGETS.CASE_LIST_SAMPLE_STATUS}>
            <div className={statusWrapperClasses}>
               <XCircularProgress value={SAMPLE_DEMAND_PROGRESS} />
            </div>
         </td>

         <td className={actionsCellClasses} data-tour={TOUR_TARGETS.CASE_LIST_SAMPLE_ACTIONS}>
            <CaseActionControls caseData={SAMPLE_CASE} setCaseIdToDelete={noop} onToggle={noop} />
         </td>
      </tr>

      <TableRowDivider colSpan={SAMPLE_COLUMN_COUNT} />
   </>
);

export default SampleCaseRow;
